import JobSearch from "@sourceflow-uk/job-search";
import { Container, Row, Col, Card } from "reactstrap";
import styles from "./styles.module.scss";
import Link from "next/link";
import Arrow from "/public/site-assets/svg/black-arrow.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper";
import useJobs from "@/hooks/useJobs";
import JobCard from '../../components/JobCard';

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";

export const LatestJobs = ({
  className,
  title,
  heading,
  content,
  jobSearch,
  buttonLink,
  buttonTitle,
  sectors,
  locations,
  featuredOnly,
}) => {
  const items = useJobs({ sectors, locations, featuredOnly });

  if (!items || !items.length > 0) {
    return null;
  }

  const settings = {
    modules: [Navigation, Pagination, Autoplay],
    loop: false,
    spaceBetween: 30,
    slidesPerView: 1,
    speed: 500,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      clickable: true,
      el: `.swiper-custom-paginations .latestJobsSwiper`,
    },
    navigation: {
      nextEl: `.latestJobsSwiper.swiper-next`,
      prevEl: `.latestJobsSwiper.swiper-prev`,
    },
    breakpoints: {
      1200: {
        slidesPerView: 4,
      },
      991: {
        slidesPerView: 3,
      },
      767: {
        slidesPerView: 2,
      },
    },
  };

  return (
    <section className={`${styles.root} ${className} grayGradientBg`}>
      <Container className="py-3 py-md-4">
        <Row className="mb-4">
          <Col md={6}>
            {title && <h2 className={`${heading} fw-bold`}>{title}</h2>}
            {content && (
              <div
                className="mb-4"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            )}
          </Col>
          <Col
            md={6}
            className="d-flex justify-content-md-end align-items-center"
          >
            {!jobSearch && (
              <div className="d-flex swiperArrowWrapper me-4">
                <button
                  className="latestJobsSwiper arrow swiper-prev border-0 p-0"
                  aria-label="Prev"
                >
                  <Arrow />
                </button>
                <button
                  className="latestJobsSwiper arrow swiper-next border-0 ms-2 p-0"
                  aria-label="Next"
                >
                  <Arrow />
                </button>
              </div>
            )}
            {!jobSearch && buttonLink && (
              <div className="text-center">
                <Link href={buttonLink}>
                  <a className="primaryBtn no-arrow m-0">{buttonTitle}</a>
                </Link>
              </div>
            )}
            {jobSearch && (
              <div className="w-100 mt-2 mt-md-0">
                <JobSearch
                  options={{
                    searchResults: false,
                    searchFilters: false,
                    submitDestination: `/jobs`,
                  }}
                  translations={{
                    "input.placeHolder": "Job Title or Keyword",
                    "button.text": "Search all jobs",
                  }}
                />
              </div>
            )}
          </Col>
        </Row>
        {jobSearch && (
          <div className="d-flex swiperArrowWrapper justify-content-end mb-4">
            <button
              className="latestJobsSwiper arrow swiper-prev border-0 p-0"
              aria-label="Prev"
            >
              <Arrow />
            </button>
            <button
              className="latestJobsSwiper arrow swiper-next border-0 ms-2 p-0"
              aria-label="Next"
            >
              <Arrow />
            </button>
          </div>
        )}
        <Swiper {...settings}>
          {items?.map((job, index) => (
            <SwiperSlide key={index}>
              <JobCard
                {...job}
                slider={true}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="text-center swiper-custom-paginations mt-4">
          <div className="latestJobsSwiper" />
        </div>
      </Container>
    </section>
  );
};

export default LatestJobs;
